module.exports = __webpack_public_path__ + "img/nerd-figure.73978d9c.jpg";